<template>
  <div v-if="mainConfig.showBidAmountsInConfirmation" class="ta-bid-confirmation-amounts">
    <BidAmount :lot="lot" :bid-amount="bidAmount"/>
    <CalculatedPremium :lot="lot" :bid-amount="bidAmount"/>
    <BidTotalAmount :lot="lot" :bid-amount="bidAmount"/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import CalculatedPremium from "@/components/lot-view/CalculatedPremium.vue";
import BidTotalAmount from "@/components/lot-view/BidTotalAmount.vue";
import BidAmount from "@/components/lot-view/BidAmount.vue";

export default {
  name: "BidAmounts",
  components: {BidAmount, BidTotalAmount, CalculatedPremium},
  mixins: [],
  props: {
    lot: Object,
    bidAmount: Number
  },
  computed: {
    ...mapState(['mainConfig'])
  },
}
</script>

<style scoped>

</style>
